import { Directive, TemplateRef, inject } from '@angular/core';
import { PdfPreviewTemplateStateService } from '@app/modules/pdf-request-form/services/pdf-preview-template-state.service';

@Directive({
  selector: '[appPdfPreview]',
  standalone: true,
})
export class PdfPreviewDirective {
  constructor() {
    const pdfPreviewTemplate = inject<TemplateRef<any>>(TemplateRef);
    const state = inject(PdfPreviewTemplateStateService);

    state.pdfTemplate = pdfPreviewTemplate;
  }
}
